function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.71694 0.5L7.44261 3.81923L11.2651 4.36948L8.50028 6.94321L9.14973 10.5997L5.71694 8.87795L2.28416 10.5997L2.9336 6.94321L0.168823 4.36948L4.00983 3.81923L5.71694 0.5Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.7547 6.00247L7.46184 3.81923L5.7547 0.5V6.00247Z",
  fill: "url(#paint0_linear_202_12862)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.68006 0.5L3.97296 3.81923L5.68006 6.00247V0.5Z",
  fill: "url(#paint1_linear_202_12862)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.66154 6.01999L4.02864 3.78351L0.187622 4.31601L5.66154 6.01999Z",
  fill: "url(#paint2_linear_202_12862)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M0.168823 4.3877L2.93361 6.96143L5.64272 6.09168L0.168823 4.3877Z",
  fill: "url(#paint3_linear_202_12862)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.66215 6.10925L2.93446 6.908L2.26645 10.5645L5.66215 6.10925Z",
  fill: "url(#paint4_linear_202_12862)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M2.32111 10.6L5.75388 8.87826L5.71677 6.14478L2.32111 10.6Z",
  fill: "url(#paint5_linear_202_12862)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M5.73609 6.14478L5.68042 8.87826L9.11321 10.6L5.73609 6.14478Z",
  fill: "url(#paint6_linear_202_12862)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M9.16891 10.5645L8.51947 6.908L5.79181 6.10925L9.16891 10.5645Z",
  fill: "url(#paint7_linear_202_12862)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M5.79181 6.07393L8.50093 6.96143L11.2657 4.3877L5.79181 6.07393Z",
  fill: "url(#paint8_linear_202_12862)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2472 4.31601L7.42471 3.78351L5.77325 6.01999L11.2472 4.31601Z",
  fill: "url(#paint9_linear_202_12862)"
});

var _ref13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_202_12862",
  x1: 5.7547,
  y1: 3.25123,
  x2: 7.46184,
  y2: 3.25123,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FDFFF3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#FCF7DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#F8E3A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#F3C34E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F1B932"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_202_12862",
  x1: 4.82651,
  y1: 6.02022,
  x2: 4.82651,
  y2: 0.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#46210E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#5F3618"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#DCA24E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#E5C466"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#EBDC77"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#EDE57D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_202_12862",
  x1: 2.93386,
  y1: 5.18575,
  x2: 3.41302,
  y2: 3.61146,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDE579"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#EBD672"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#E6B964"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#E2B561"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#D8A959"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#C6954B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopColor: "#AD7937"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A57031"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_202_12862",
  x1: 3.47172,
  y1: 6.80168,
  x2: 2.42666,
  y2: 3.61374,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#46210E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#B9873C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_202_12862",
  x1: 4.45602,
  y1: 8.91373,
  x2: 2.92833,
  y2: 6.91283,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#A77232"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#C99844"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#DEB050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_202_12862",
  x1: 6.19922,
  y1: 7.77777,
  x2: 1.86888,
  y2: 9.06841,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_202_12862",
  x1: 166.301,
  y1: 35.9502,
  x2: 163.041,
  y2: 41.0131,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_202_12862",
  x1: 7.0907,
  y1: 5.914,
  x2: 8.12847,
  y2: 12.9568,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#46210E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#AA7534"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#DCA24E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_202_12862",
  x1: 8.44526,
  y1: 5.04444,
  x2: 9.09826,
  y2: 6.73308,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#A77232"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#C99844"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#DEB050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_202_12862",
  x1: 10.5977,
  y1: 5.94899,
  x2: 6.47252,
  y2: 4.28151,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEAC1F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#EFB534"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#F3CD6C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#F9F3C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FBFFE1"
})));

function SvgListStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListStar);
export default __webpack_public_path__ + "static/media/list-star.2e0e5c87.svg";
export { ForwardRef as ReactComponent };